import {filter, products} from '../routes/navigation';
import {Route, allUpdatesNew} from '../routes/navigation';
import {Experiment} from '../reducers/experiments';

export const validatePath = path => {
  const regex = /[^/?]+/g;
  const match = regex.exec(path);
  return `/${!!match && match[0] !== 'page' ? match[0] : ''}`;
};

export const getTagByPath = (path, experiments: Experiment[] = []) => {
  const cleanPath = (path === '/corvid') ? '/velo' : validatePath(path);
  const allRoutes = filter(experiments).concat(products());
  let tag = '';
  allRoutes.forEach(route => {
    if (route.path === cleanPath) {
      tag = route.tag;
    }
  });

  return tag;
};

export interface RouteData extends Route {}

export const getLabelByPath = (path, experiments?) => {
  const cleanPath = validatePath(path);
  const allRoutes = filter(experiments).concat(products());
  let label = '';
  allRoutes.forEach(route => {
    if (route.path === cleanPath) {
      label = route.labelForHeader || route.label;
    }
  });

  return label;
};

export const getRouteData = (path, experiments?): RouteData => {
  const cleanPath = validatePath(path);
  const allRoutes = filter(experiments).concat(products());
  let currentRoute = allUpdatesNew;
  allRoutes.forEach(route => {
    if (route.path === cleanPath) {
      currentRoute = route;
    }
  });

  return currentRoute;
};

export const generateArticleAbsoluteLink = articleId => {
  if (window === undefined) {
    return '';
  }
  return `${window.location.origin}/${window.__BASEURL__}/article/${articleId}`;
};

export const getPageIndex = pathname => {
  const regex = /page\/(\d*)/g;
  const match = regex.exec(pathname);
  return match && match[1].length !== 0 ? match[1] : 1;
};

export const screenResolution = {
  medium: 1024
};

export const isWindowWidthInRange = width => {
  try {
    return window && window.innerWidth <= width;
  } catch (e) {
    return false;
  }
};
